import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useShallow } from "zustand/react/shallow";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { useUserStore } from "../../../store/userStore";
import Button from "../../atoms/Button";

function RegisterNow() {
  const { t } = useTranslation(["common"]);
  const { pathname } = useLocation();
  const [display, setDisplay] = useState(false);

  const { accessToken } = useUserStore(
    useShallow((state) => ({
      accessToken: state.accessToken,
    }))
  );

  useEffect(() => {
    if (pathname.includes("login") || pathname.includes("register")) {
      setDisplay(false);
    } else {
      setDisplay(true);
    }
  }, [pathname]);

  if (accessToken || !display) {
    return null;
  }

  return (
    <div className="bg-surface-secondary text-center flex flex-col items-center justify-center gap-5 py-10">
      <h2 className="text-2xl font-bold text-text-inverted max-w-80">
        {t("registerNow.title")}
      </h2>
      <Button
        style="primary"
        link="/register"
        className="px-5 py-3 gap-2 flex flex-row items-center justify-center"
      >
        {t("registerNow.getStarted")}
        <ChevronRightIcon className="w-5 h-5 text-text-inverted" />
      </Button>
    </div>
  );
}

export default RegisterNow;
